import { ISurveyIn, ISurveyUpdateIn } from "../../models/input/surveyApi/ISurveyIn";
import * as ApiWithToken from "../callApiWithToken";

const surveyService = {
    getSurveys: async function () {
        return ApiWithToken.getApi(process.env.REACT_APP_SURVEY_API + `Surveys/GetSurveys`);
    },
    getSurveyDetail: async function (surveyId: number) {
        return ApiWithToken.getApi(process.env.REACT_APP_SURVEY_API + `Surveys/GetSurveyDetail?SurveyID=${surveyId}`);
    },
    deleteSurvey:async function(surveyId: number){
        return ApiWithToken.deleteApi(process.env.REACT_APP_SURVEY_API + `Surveys/DeleteSurvey?SurveyID=${surveyId}`);
    },
    getCitiesByCountry: async function (countryIds: string) {
        return ApiWithToken.getApi(process.env.REACT_APP_SURVEY_API + `Surveys/GetCitiesByCountry?CountryIDs=${countryIds}`);
    },
    getRoleList: async function (languageId: number, roleTypeId: number) {
        return ApiWithToken.getApi(process.env.REACT_APP_SURVEY_API + `Surveys/GetRoleList?LanguageID=${languageId}&RoleTypeID=${roleTypeId}`);
    },
    postSurvey: async function (surveyIn: ISurveyIn) {
        return ApiWithToken.postApi(process.env.REACT_APP_SURVEY_API + `Surveys/CreateSurvey`, surveyIn);
    },
    updateSurvey: async function (surveyUpdateIn: ISurveyUpdateIn) {
        return ApiWithToken.putApi(process.env.REACT_APP_SURVEY_API + `Surveys/UpdateSurvey`, surveyUpdateIn);
    },

}
export default surveyService;
